<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPresentationOff_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M14.75 19h-5.5l-.726 2.177a.625.625 0 0 0 .593.823h5.766a.625.625 0 0 0 .593-.823zM4.124 2.24a.625.625 0 0 0-.884.884l1.032 1.032A2.58 2.58 0 0 0 2.5 6.6v8.8A2.6 2.6 0 0 0 5.1 18h13.016l1.969 1.97a.623.623 0 0 0 .884 0 .625.625 0 0 0 0-.884zM5.1 16a.6.6 0 0 1-.6-.6V6.6a.6.6 0 0 1 .6-.6h1.017l9.999 10zM18.9 4H7.652l2 2H18.9a.6.6 0 0 1 .6.6v8.8a.6.6 0 0 1-.115.334l1.422 1.422A2.59 2.59 0 0 0 21.5 15.4V6.6A2.6 2.6 0 0 0 18.9 4"
    />
</svg>
